import $ from "cash-dom"
import _ from "lodash"
import React from "react"
import rollbar_helper from "rollbar_helper"
import {createRoot} from "react-dom/client"
import EmbeddedQuiz from "../components/embedded_quiz/embedded_quiz"
import ModalProvider from "../modal_provider"
import viewport_helper from "viewport_helper"
import lazy_loader from "lazy_loader"
import init_sample_quiz from "./sample_quiz"
import ajax from "ajax"

function init_embedded_quizzes() {
  move_viewport_to_embedded_quiz()
  lazy_loader.add($(".embedded-quiz-container"), (el) => {
    if (
      !window.gon.current_user &&
      window.location.pathname.match(/\/library\//)
    ) {
      init_sample_quiz(el, 3)
    } else {
      init_embedded_quiz(el).then(move_viewport_to_embedded_quiz)
    }
  })
}

export function init_embedded_quiz(container) {
  const url_params = (new URL(window.location)).searchParams
  const $container = $(container)
  const quiz_id = $container.data("quiz-id")
  return get_quiz_data(quiz_id).then((quiz) => {
    createRoot(container).render(
      <ModalProvider>
        <EmbeddedQuiz
          quiz_id={quiz_id}
          quiz={quiz}
          current_user={window.gon.current_user}
          tracking_data={create_tracking_data(quiz)}
          quiz_just_finished={url_params.get("summary") === `quiz-${quiz.id}`}
        />
      </ModalProvider>
      ,
    )
    $container.removeClass("spinner")
  })
}

export const move_viewport_to_embedded_quiz = () => {
  const url = new URL(window.location)
  const identifier = url.searchParams.get("summary")
  if (!identifier) return
  try {
    // the quiz_slug is taken from the url and could be altered by the user
    // that's why we have to catch a possible error here
    viewport_helper.go_to(`#${identifier}`)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  }
}

const create_tracking_data = (quiz) => {
  const tracking_data =
    window.gon.tracking?.study_unit ||
    window.gon.tracking?.article ||
    {}
  if (!tracking_data || !quiz?.tracking_data) {
    rollbar_helper.send_error_msg("Tracking data is null or undefined", {
      tracking_data: JSON.stringify(tracking_data),
      quiz: JSON.stringify(quiz)
    })
  }
  return Object.assign(
    quiz.tracking_data,
    _.pick(tracking_data, [
      "section_slug",
      "lecture_slug",
      "chapter_slug"
    ])
  )
}

function get_quiz_data(id) {
  return ajax.get(
    `/api/quizzes/${id}.json?locale=${window.gon.locale}`
  )
}

export default init_embedded_quizzes
